<script setup>
import { Select } from '@components'
import useVisitor from '@stores/visitor'
const visitor = useVisitor()
</script>

<template>
    <div class="relative">
        <!-- main chart  -->
        <div class="flex justify-between items-center">
            <Heading>WP Dark Mode Usage</Heading>
            <div class="w-fit">
                <Select v-model="visitor.reportInterval" :options="visitor.reportIntervals" @select="visitor.updateChart"></Select>
            </div>
        </div>
        <canvas ref="ctx" id="wp-dark-mode-chart" class="w-full max-w-xl mx-auto h-auto"></canvas>
    </div>
</template>
